import axios from "axios";
const { REACT_APP_API_BASE_URL, REACT_APP_AUTH_BASE_URL } = process.env;
export const instance = (auth = false) => {
  return axios.create({
    baseURL: auth ? REACT_APP_AUTH_BASE_URL : REACT_APP_API_BASE_URL,
    headers: { "Content-Type": "application/json" },
  });
};
